/*
 * Zarafae "Cut to Measure": phone gallery dots (critique item product-gallery-swipe-zoom).
 *
 * Loaded with type="module" by snippets/product-media-gallery-content.liquid while the product
 * media block's "Cut to Measure gallery" setting is on. Under 750px the gallery is Horizon's own
 * slideshow (assets/slideshow.js) with the next photo peeking. Its dots are plain buttons
 * ([data-zf-gallery-dot]) that call the slideshow's select() through on:click="/select/N".
 *
 * The slideshow dispatches slideshow:select (it bubbles) whenever the photo changes: a dot tap, a
 * swipe or drag, a desktop thumbnail, or the zoom viewer moving to another photo. This module
 * mirrors that index onto the dots as aria-current="true", which the CSS fills in ink.
 *
 * It is one document-level listener behind a window flag, so it keeps working when
 * media-gallery.js swaps the whole gallery on a Dupatta change and after theme editor reloads.
 * New markup starts at photo 1 from Liquid.
 */

const SELECT_EVENT = 'slideshow:select';
const DOT = '[data-zf-gallery-dot]';

/** @param {Event} event */
function handleSelect(event) {
  const slideshow = event.target;
  if (!(slideshow instanceof Element) || slideshow.localName !== 'slideshow-component') return;

  const dots = Array.from(slideshow.querySelectorAll(DOT)).filter(
    (dot) => dot.closest('slideshow-component') === slideshow
  );
  if (!dots.length) return;

  const detail = /** @type {{ detail?: { index?: unknown } }} */ (/** @type {unknown} */ (event)).detail;
  const index = Number(detail ? detail.index : NaN);
  if (!Number.isInteger(index) || index < 0 || index >= dots.length) return;

  dots.forEach((dot, i) => {
    if (i === index) {
      dot.setAttribute('aria-current', 'true');
    } else {
      dot.removeAttribute('aria-current');
    }
  });
}

if (!window.__zfProductGalleryInit) {
  window.__zfProductGalleryInit = true;
  document.addEventListener(SELECT_EVENT, handleSelect);
}
